module.exports = __webpack_public_path__ + "assets/img/teren@2x.f64ba487.png";